import React from "react";
import PropTypes from "prop-types";
import { Image } from "react-bootstrap";
import styles from "./CafeNameAvatar.module.scss";

export const isUsableCafeImageUrl = (url) =>
  typeof url === "string" && url.trim().length > 0;

export function getCafeInitials(name) {
  if (!name || typeof name !== "string") {
    return "?";
  }
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
  }
  const word = parts[0] || "";
  if (word.length >= 2) {
    return word.slice(0, 2).toUpperCase();
  }
  return word.slice(0, 1).toUpperCase() || "?";
}

function CafeNameAvatar({
  name,
  src,
  size,
  imageLoadFailed,
  onImageError,
  interactive,
  onClick,
  onKeyDown,
  ariaLabel,
  overlay,
  className,
}) {
  const showPhoto = isUsableCafeImageUrl(src) && !imageLoadFailed;
  const initials = getCafeInitials(name);
  const fontSize = Math.max(14, Math.round(size * 0.32));

  return (
    <div
      className={`${styles.wrapper} ${interactive ? styles.interactive : ""} ${className || ""}`}
      style={{ width: size, height: size }}
      onClick={interactive ? onClick : undefined}
      onKeyDown={interactive ? onKeyDown : undefined}
      role={interactive ? "button" : "img"}
      tabIndex={interactive ? 0 : -1}
      aria-label={ariaLabel}
    >
      {showPhoto ? (
        <Image
          src={src.trim()}
          alt=""
          aria-hidden="true"
          className={styles.image}
          onError={onImageError}
        />
      ) : (
        <div
          className={styles.initials}
          style={{ fontSize }}
          aria-hidden="true"
        >
          {initials}
        </div>
      )}
      {overlay ? <div className={styles.overlay}>{overlay}</div> : null}
    </div>
  );
}

CafeNameAvatar.propTypes = {
  name: PropTypes.string,
  src: PropTypes.string,
  size: PropTypes.number,
  imageLoadFailed: PropTypes.bool,
  onImageError: PropTypes.func,
  interactive: PropTypes.bool,
  onClick: PropTypes.func,
  onKeyDown: PropTypes.func,
  ariaLabel: PropTypes.string,
  overlay: PropTypes.node,
  className: PropTypes.string,
};

CafeNameAvatar.defaultProps = {
  name: "",
  src: "",
  size: 100,
  imageLoadFailed: false,
  onImageError: () => {},
  interactive: false,
  onClick: undefined,
  onKeyDown: undefined,
  ariaLabel: "Cafe photo",
  overlay: null,
  className: "",
};

export default CafeNameAvatar;
